import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from './store';
import { Logger as AppLogger } from '../lib/utils';
import { getApiBaseUrl } from '../lib/apiBaseUrl';

const API_BASE_URL = getApiBaseUrl();

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      try {
        const state = getState() as RootState;
        const token = state?.auth?.token;
        const tenantId = state?.auth?.tenantId;

        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }

        if (tenantId) {
          headers.set('x-empresa-id', String(tenantId));
        }
      } catch (error) {
        AppLogger.error('Error accessing auth state in prepareHeaders:', error);
      }
      return headers;
    },
  }),
  tagTypes: ['User', 'Empresa', 'NoragDomain', 'NoragTemplate', 'NoragJob', 'NoragStats', 'NoragFolder', 'NoragBook', 'NoragBot', 'NoragHierarchy', 'NoragExpediente', 'NoragCopilot'],
  keepUnusedDataFor: 300,
  refetchOnMountOrArgChange: 30,
  refetchOnFocus: false,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});

export default apiSlice;
